module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_vm._m(0), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(1), _vm._v(" "), (_vm.$route.meta.parent) ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.meta.parent.name
      }
    }
  }, [_vm._v(_vm._s(_vm.$route.meta.parent.name.toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": "/static/img/suez-white.png",
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-lg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/suez-white.png",
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f7f164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1811
// module chunks = 2